import { IsBoolean, IsNumber, IsOptional } from 'class-validator';

export class UserResponsivenessDto {
  @IsOptional()
  @IsNumber()
  averageResponseTimeHours?: number;

  @IsOptional()
  @IsNumber()
  responseRatePercent?: number;

  @IsOptional()
  @IsBoolean()
  isHighlyResponsive?: boolean;

  @IsOptional()
  @IsNumber()
  totalActionsCount?: number;

  @IsOptional()
  @IsNumber()
  expiredActionsCount?: number;

  @IsOptional()
  @IsNumber()
  totalResponseTimeHours?: number;
}
